import styled from 'styled-components';

import { COLOR } from 'constants/color';

export const SelectStyle = styled.div`
  .value-select,
  .dropdown-item {
    font-size: 16px;
    line-height: 22px;
    color: #1f1f1f;
  }

  .selected svg path {
    stroke: ${COLOR.primary['primary-6']};
  }

  .dropdown {
    background: #ffffff;
  }
`;
